import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Banque, BankAccount, BanqueResponse } from '../../models/banque.model';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BanqueService {
    private apiUrl = `${environment.parameters_url}api/settings/banque`;
    private apiUrlStation = `${environment.parameters_url}api/settings/global/banques`;
  constructor(private http: HttpClient) {}

  getBanques(idStation: number): Observable<BanqueResponse> {
    return this.http.get<BanqueResponse>(`${this.apiUrl}/${idStation}`);
  }

  getAllBanques(): Observable<BanqueResponse> {
    return this.http.get<BanqueResponse>(`${this.apiUrlStation}`);
  }

  addBanque(idStation: number, banque: Banque): Observable<BankAccount> {
    return this.http.post<BankAccount>(`${this.apiUrl}/${idStation}`, banque);
  }

  updateBanque(idStation: number, id: number, banque: Banque): Observable<BankAccount> {
    return this.http.put<BankAccount>(`${this.apiUrl}/${idStation}/${id}`, banque);
  }
}
